module.exports = __webpack_public_path__ + "img/logo.33f1e95e.png";